import { Link, useLocation } from "react-router-dom";
import { COMPANY } from "../data/company";

export default function Footer() {
  const { pathname } = useLocation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#111111] text-white border-t border-neutral-800 mt-auto">
      {/* Top CTA banner inside footer */}
      {!["/kontakt", "/ydelser"].includes(pathname.replace(/\/+$/, "")) && (
      <div className={`${pathname === "/" || pathname.startsWith("/ydelser/") ? "bg-[#FAFAF8]" : "bg-white"} text-[#111111]`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-12">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <span className="text-[#A78E51] font-bold text-xs uppercase tracking-widest block mb-1">
                Kvalitetshåndværk på Fyn
              </span>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-[#111111] tracking-tight">
                Har du et projekt til Andreas?
              </h2>
              <p className="text-neutral-600 text-sm mt-1 max-w-xl">
                Uanset om det gælder nye døre og vinduer, en flot træterrasse eller indendørs renovering af lofter og vægge, er du velkommen til at kontakte os for en uforpligtende snak.
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-3 w-full md:w-auto">
              <a
                href={COMPANY.phoneLink}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-[#A78E51] text-white font-bold text-sm hover:bg-[#937B43] transition-colors whitespace-nowrap"
              >
                <i className="fa-solid fa-phone" aria-hidden="true" />
                <span className="whitespace-nowrap">Ring {COMPANY.phone}</span>
              </a>
              <Link
                to="/kontakt"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-white text-[#111111] hover:text-[#A78E51] font-bold text-sm transition-colors whitespace-nowrap"
              >
                <span>Skriv til os</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
      )}

      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Col 1: Om virksomheden */}
          <div className="space-y-4">
            <div className="flex items-center gap-3.5 rounded-md py-1">
              <img
                src="https://assets.auxodev.dk/assets/3fc68df7-bc32-4dbe-a468-aab3c89985d1/22126ce9-8ad3-418a-9671-b575fa8f59aa.png"
                alt="Tømrermester Andreas Guldmann logo"
                className="w-11 h-11 object-contain"
              />
              <div className="flex flex-col">
                <span className="font-bold text-base sm:text-lg leading-tight tracking-tight text-white">
                  Tømrermester
                </span>
                <span className="font-bold text-base sm:text-lg leading-tight tracking-tight text-[#A78E51]">
                  Andreas Guldmann
                </span>
              </div>
            </div>

            <p className="text-neutral-400 text-sm leading-relaxed">
              Professionelt tømrerarbejde med fokus på solidt håndværk, god dialog og holdbare løsninger inden for døre & vinduer, træterrasser og udendørsarealer samt indendørs renovering af lofter og vægge.
            </p>

            <div className="pt-2">
              <a
                href={COMPANY.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 text-xs text-neutral-300 hover:text-[#A78E51] transition-colors py-1.5 px-3 rounded bg-neutral-900 border border-neutral-800 hover:border-[#A78E51]/40"
              >
                <i className="fa-brands fa-facebook-f text-sm text-[#A78E51]" aria-hidden="true" />
                <span>Følg os på Facebook</span>
              </a>
            </div>
          </div>

          {/* Col 2: Ydelser */}
          <div>
            <h3 className="text-white text-sm font-bold uppercase tracking-wider mb-4 border-l-2 border-[#A78E51] pl-3">
              Ydelser
            </h3>
            <ul className="space-y-2.5 text-sm">
              {COMPANY.services.map((svc) => (
                <li key={svc.slug}>
                  <Link
                    to={svc.path}
                    className="text-neutral-400 hover:text-[#A78E51] transition-colors flex items-center gap-2 group"
                  >
                    <i className="fa-solid fa-angle-right text-[10px] text-neutral-600 group-hover:text-[#A78E51] transition-colors" aria-hidden="true" />
                    <span>{svc.title}</span>
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/ydelser"
                  className="text-neutral-400 hover:text-[#A78E51] transition-colors flex items-center gap-2 group pt-1"
                >
                  <i className="fa-solid fa-angle-right text-[10px] text-neutral-600 group-hover:text-[#A78E51] transition-colors" aria-hidden="true" />
                  <span className="font-semibold text-neutral-300">Se alle ydelser</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Hurtige links */}
          <div>
            <h3 className="text-white text-sm font-bold uppercase tracking-wider mb-4 border-l-2 border-[#A78E51] pl-3">
              Genveje
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-neutral-400 hover:text-[#A78E51] transition-colors flex items-center gap-2 group">
                  <i className="fa-solid fa-angle-right text-[10px] text-neutral-600 group-hover:text-[#A78E51] transition-colors" aria-hidden="true" />
                  <span>Forside</span>
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="text-neutral-400 hover:text-[#A78E51] transition-colors flex items-center gap-2 group">
                  <i className="fa-solid fa-angle-right text-[10px] text-neutral-600 group-hover:text-[#A78E51] transition-colors" aria-hidden="true" />
                  <span>Projektgalleri</span>
                </Link>
              </li>
              <li>
                <Link to="/om-andreas" className="text-neutral-400 hover:text-[#A78E51] transition-colors flex items-center gap-2 group">
                  <i className="fa-solid fa-angle-right text-[10px] text-neutral-600 group-hover:text-[#A78E51] transition-colors" aria-hidden="true" />
                  <span>Om Andreas Guldmann</span>
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-neutral-400 hover:text-[#A78E51] transition-colors flex items-center gap-2 group">
                  <i className="fa-solid fa-angle-right text-[10px] text-neutral-600 group-hover:text-[#A78E51] transition-colors" aria-hidden="true" />
                  <span>Kontakt & tilbud</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Stamdata & Kontakt */}
          <div>
            <h3 className="text-white text-sm font-bold uppercase tracking-wider mb-4 border-l-2 border-[#A78E51] pl-3">
              Kontaktoplysninger
            </h3>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-[#A78E51] mt-1 shrink-0" aria-hidden="true" />
                <div>
                  <span className="block text-white font-medium">{COMPANY.street}</span>
                  <span className="text-neutral-400">{COMPANY.postalAndCity}</span>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-[#A78E51] shrink-0" aria-hidden="true" />
                <a
                  href={COMPANY.phoneLink}
                  className="hover:text-[#A78E51] transition-colors whitespace-nowrap text-white font-medium"
                >
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-[#A78E51] shrink-0" aria-hidden="true" />
                <a
                  href={COMPANY.emailLink}
                  className="hover:text-[#A78E51] transition-colors whitespace-nowrap text-neutral-300 hover:underline"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-center gap-3 pt-1 border-t border-neutral-800 text-xs text-neutral-400">
                <span className="text-[#A78E51] font-semibold">CVR:</span>
                <span>{COMPANY.cvr}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom copyright & Auxo credit */}
        <div className="border-t border-neutral-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-neutral-400">
          <p>
            &copy; {currentYear} {COMPANY.name}. Alle rettigheder forbeholdes.
          </p>
          <p className="flex items-center gap-1.5">
            <span>Designet af</span>
            <a
              href="https://auxo.dk"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#A78E51] hover:text-[#937B43] font-semibold underline underline-offset-2 transition-colors"
            >
              Auxo
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
